// extracted by mini-css-extract-plugin
export default {"cls1":"CitationModal-cls1__d44a606c7f91aaed51c6","cls2":"CitationModal-cls2__d11fb483d94d1a219382 CitationModal-cls1__d44a606c7f91aaed51c6"};